import React from 'react';
import Slider from 'react-slick';
import { css } from '@emotion/core';

import SlickArrow from '../../../shared/SlickArrow/SlickArrow';

import './BigBanner.scss';
import SlickArrowCircleSecondary from '../../../shared/SlickArrow/SlickArrowCircleSecondary';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const BigBanner = ({
  home,
  secondaryColor,
  withThumbnails = false,
  sliderCircleArrowsBanner,
  sliderNavigationDots,
  heroBannerVersion,
}) => {
  const {
    sliderTopSlide1Image: slide1Image,
    sliderTopSlide1Link: slide1Link,
    sliderTopSlide1SeoName: slide1SeoName,
    sliderTopSlide2Image: slide2Image,
    sliderTopSlide2Link: slide2Link,
    sliderTopSlide2SeoName: slide2SeoName,
    sliderTopSlide3Image: slide3Image,
    sliderTopSlide3Link: slide3Link,
    sliderTopSlide3SeoName: slide3SeoName,
    sliderTopSlide4Image: slide4Image,
    sliderTopSlide4Link: slide4Link,
    sliderTopSlide4SeoName: slide4SeoName,
    sliderTopSlide5Image: slide5Image,
    sliderTopSlide5Link: slide5Link,
    sliderTopSlide5SeoName: slide5SeoName,
    sliderTopSlide6Image: slide6Image,
    sliderTopSlide6Link: slide6Link,
    sliderTopSlide6SeoName: slide6SeoName,
  } = home;

  const dotsStyle = css`
    .slick-dots {
      display: flex !important;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 5%;

      & li > .dot {
        height: 14px;
        width: 14px;
        background-color: #ffff;
        border: 1px solid #dfdfdf;
        border-radius: 50%;

        @media (max-width: 992px) {
          height: 2px;
          width: 2px;
        }

        &:hover,
        &.active {
          background-color: ${secondaryColor};
        }
        &::before {
          color: none;
          content: none;
          opacity: 0;
        }
      }

      & > .slick-active {
        background-color: transparent;

        & .dot {
          background-color: ${secondaryColor};
        }
      }
    }
  `;

  const getThumbnailImage = num => {
    switch (num) {
      case 1:
        return slide1Image;
      case 2:
        return slide2Image;
      case 3:
        return slide3Image;
      case 4:
        return slide4Image;
      case 5:
        return slide5Image;
      case 6:
        return slide6Image;
      default:
        return null;
    }
  };

  const settings = {
    arrows: true,
    prevArrow:
      sliderCircleArrowsBanner === 1 && heroBannerVersion == 1 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsBanner === 1 && heroBannerVersion == 2 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsBanner === 0 ? (
        <SlickArrow />
      ) : sliderCircleArrowsBanner === 1 && heroBannerVersion == 3 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : null,
    nextArrow:
      sliderCircleArrowsBanner === 1 && heroBannerVersion == 1 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsBanner === 1 && heroBannerVersion == 2 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsBanner === 0 ? (
        <SlickArrow />
      ) : sliderCircleArrowsBanner === 1 && heroBannerVersion == 3 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : null,
    dots: sliderNavigationDots === 1 ? true : false,
    customPaging: function(i) {
      return !!withThumbnails ? (
        <a style={{ backgroundImage: `url(${getThumbnailImage(i + 1)})` }} />
      ) : (
        <button className="dot" />
      );
    },
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className={`big-banner ${heroBannerVersion === 3 ? 'rounded' : ''}`}>
      <div
        className={heroBannerVersion !== 3 ? 'container-fluid' : 'container'}
        style={{ padding: '0px' }}
      >
        <div className="col-lg-12">
          <Slider
            {...settings}
            className={`variant-${heroBannerVersion}`}
            css={dotsStyle}
          >
            {slide1Image && (
              <div>
                <a href={slide1Link}>
                  <ImageDispatcher
                    src={slide1Image}
                    alt={slide1SeoName}
                    className="img-fluid"
                  />
                </a>
              </div>
            )}
            {slide2Image && (
              <div>
                <a href={slide2Link}>
                  <ImageDispatcher
                    src={slide2Image}
                    alt={slide2SeoName}
                    className="img-fluid"
                  />
                </a>
              </div>
            )}
            {slide3Image && (
              <div>
                <a href={slide3Link}>
                  <ImageDispatcher
                    src={slide3Image}
                    alt={slide3SeoName}
                    className="img-fluid"
                  />
                </a>
              </div>
            )}
            {slide4Image && (
              <div>
                <a href={slide4Link}>
                  <ImageDispatcher
                    src={slide4Image}
                    alt={slide4SeoName}
                    className="img-fluid"
                  />
                </a>
              </div>
            )}
            {slide5Image && (
              <div>
                <a href={slide5Link}>
                  <ImageDispatcher
                    src={slide5Image}
                    alt={slide5SeoName}
                    className="img-fluid"
                  />
                </a>
              </div>
            )}
            {slide6Image && (
              <div>
                <a href={slide6Link}>
                  <ImageDispatcher
                    src={slide6Image}
                    alt={slide6SeoName}
                    className="img-fluid"
                  />
                </a>
              </div>
            )}
          </Slider>
          {withThumbnails && <div />}
        </div>
      </div>
    </div>
  );
};

export default BigBanner;

// heroBannerVersion 1 e 2 : container-fluid, full-page
// heroBannerVersion 3: container, centered, with rounded corners
